import { useEffect, useState } from 'react';

export const useRefreshingJoinPeriod = (compute: () => boolean) => {
  const [isJoinPeriod, setIsJoinPeriod] = useState(compute);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
    setIsJoinPeriod(compute());
    const intervalId = setInterval(() => {
      setIsJoinPeriod(compute());
    }, 5000);
    return () => {
      clearInterval(intervalId);
    };
  }, [compute]);

  return isJoinPeriod;
};
